import { generateKeys } from '../utils';
export const blacklistTypes = generateKeys({
    email: {
        value: 'email',
        label: 'Email',
    },
    phone: {
        value: 'phone',
        label: 'Phone',
    },
    ipAddress: {
        value: 'ipAddress',
        label: 'IP address',
    },
    country: {
        value: 'country',
        label: 'Country',
    },
});
